import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from '../router'
import throttle from 'lodash/throttle'
import API from '../interface/api'
import HOSTURL from '../interface/host'
import { Toast } from 'vant'
Vue.use(Toast)

// axios 配置
axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL = HOSTURL

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    if (store.state.token) {
      config.headers['Access-Token'] = `${store.state.token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
})

// http response 拦截器
axios.interceptors.response.use(
  response => {
    let status = response.data.status
    if (status === 200 || status === 405) {
      return response.data
    } else if (status === 410) {
      console.log('errMsg：用户未登陆或token已失效')
      store.commit('logout')
      if (router.currentRoute.name.indexOf('topic') > -1) {
        router.replace({
          path: '/'+ router.currentRoute.name +'/login'
        })
      } else {
        let u = navigator.userAgent
        if (u.indexOf('MicroMessenger') > -1) {
          console.log('微信授权登录中...')
          axios.post(API.GETWECHATAUTHURI, {
            url: window.location.href
          })
            .then(response => {
              if (response.status === 200) {
                console.log(response)
                window.location.href = response.data.uri
                // router.go(0)
              } else {
                console.log(response.message)
              }
            })
        } else {
          console.log('请登录...')
          if (router.currentRoute.path.indexOf('competition') > -1) {
            Toast.fail('请在微信内打开')
          } else {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath,
                id: router.currentRoute.query.id ? router.currentRoute.query.id : ''
              }
            })
          }
        }
      }
    } else {
      throttle(() => {
        let errorMsg = response.data.message || '授权失败'
        Toast.fail(errorMsg);
      }, 500)
    }
    return Promise.reject(response.data)
  },
  throttle(
    function (error) {
      if (typeof error.response !== 'undefined') {
        switch (error.response.status) {
          case 410:
            console.log('errMsg：用户未登陆或token已失效')
            store.commit('logout')
            if (router.currentRoute.name.indexOf('topic') > -1) {
              router.replace({
                path: '/'+ router.currentRoute.name +'/login'
              })
            } else {
              let u = navigator.userAgent
              if (u.indexOf('MicroMessenger') > -1) {
                console.log('微信授权登录中...')
                axios.post(API.GETWECHATAUTHURI, {
                  url: window.location.href
                })
                  .then(response => {
                    if (response.status === 200) {
                      console.log(response)
                      window.location.href = response.data.uri
                      router.go(0)
                    } else {
                      console.log(response.message)
                    }
                  })
              } else {
                console.log('请登录...')
                if (router.currentRoute.path.indexOf('competition') > -1) {
                  Toast.fail('请在微信内打开')
                } else {
                  router.replace({
                    path: '/login',
                    query: {
                      redirect: router.currentRoute.fullPath,
                      id: router.currentRoute.query.id ? router.currentRoute.query.id : ''
                    }
                  })
                }
              }
            }
        }
      }
      console.log(error)
      try {
        let errorMsg = error.response.data.message || '请求失败，请检查访问地址是否正确'
        Toast.fail(errorMsg);
      } catch (e) {
        console.log(e)
        Toast.fail('请求失败，请检查网络是否畅通');
      }
    },
    500
  )
)

const ajax = (method, url, params = {}, options) => {
  let [_params, _data] = method === 'get' ? [params, ''] : ['', params]
  let _options = Object.assign({
    method: method,
    url: url,
    params: _params,
    data: _data
  }, options)
  return axios(_options)
}

const fetch = {
  get: (url, params = {}, options) => {
    return ajax('get', url, params, options)
  },
  post: (url, params = {}, options) => {
    return ajax('post', url, params, options)
  }
}

export default fetch